import { render, staticRenderFns } from "./Instagram-integration.vue?vue&type=template&id=4fe0d1d2&"
import script from "./Instagram-integration.vue?vue&type=script&lang=js&"
export * from "./Instagram-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports